import React, { useContext } from 'react';
import styles from './LocationCard.module.scss';
import { SFBlue, SFCard, SFIcon, SFText } from 'sfui';
import { AppearanceContext } from 'ui-smartforce-settings';

export interface LocationCardProps {
  className?: string;
  location: string;
}

export const LocationCard = ({
  className = '',
  location
}: LocationCardProps): React.ReactElement<LocationCardProps> => {
  const { themeType } = useContext(AppearanceContext);

  return (
    <SFCard
      className={`${styles.locationCard} ${className}`}
      containerClassName={styles.locationCardContainer}
      sfElevation={1}
    >
      <SFIcon
        icon="Loction-1"
        size={20}
        color={themeType === 'day' ? SFBlue[400] : SFBlue[300]}
      />
      <div className={styles.info}>
        <SFText type="component-3-medium" sfColor="default">
          {location}
        </SFText>
      </div>
    </SFCard>
  );
};
